module.exports = __webpack_public_path__ + "static/img/wuxi1.75067c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/homePortal/wuxi1.jpg
// module id = /+z1
// module chunks = 1